<template>
  <master-layout pageTitle="API Reference">
    <div class=" sectionPadding feature-card-container">
      <div class="feature-card-wrapper" v-for="product in products" :key="product.id" >
        <ApiReferenceCard
          :image="product.image"
          :title="capitalize(product.name)"
          :description="product.description"
          :link="product.link"
        />
      </div>
    </div>
  </master-layout>
</template>

<script>
import ApiReferenceCard from "./api-reference-card.vue";
import apiInterceptor from "@/shared/apiInterceptor";
import customerIcon from "@/resources/images/customersApiReferenceIcon.png";
import messageIcon from "@/resources/images/messagesApiReferenceIcon.png";
import templateIcon from "@/resources/images/templatesApiReferenceIcon.png";
import authIcon from "@/resources/images/auth_developer.svg";
import { useUIStore } from '@/stores/ui';
import { environment } from '@/shared/env.js';

export default {
  components: {
    ApiReferenceCard,
  },

  data() {
    return {
      featureLoading: false,
      products: [],

      // Image mapping by product name
      productImageMap: {
        customers: customerIcon,
        messages: messageIcon,
        "connect messaging api": messageIcon,
        templates: templateIcon,
        oauth: authIcon,
      },
    };
  },

  mounted() {
    this.fetchProducts();
  },

  methods: {
    capitalize(text) {
      return text.charAt(0).toUpperCase() + text.slice(1);
    },

    async fetchProducts() {
      try {
        useUIStore().updateLoading({ isLoading: true, message: 'Loading API references...' });

        const productsList = await apiInterceptor.get(
          environment("VUE_APP_APIGEE_API_URL") + "metadata/products"
        );
        this.products = productsList.products.map((p) => ({
          id: p.id,
          name: p.name,
          description: p.description,
          link: p.documentation_url,
          image: this.productImageMap[p.name.toLowerCase()] || customerIcon,
        }));
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error?.response?.data?.detail || "Something went wrong!",
          type: "danger",
        });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
  },
};
</script>

<style scoped>
.feature-card-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: stretch;
}

.feature-card-wrapper {
  flex: 1 1 calc(33.333% - 20px);
  min-width: 280px;
  max-width: 457px;
  display: flex;
}

.feature-card-wrapper > * {
  flex: 1;
  height: 100%;
}

@media (max-width: 1024px) {
  .feature-card-wrapper {
    flex: 1 1 calc(50% - 16px);
    max-width: none;
  }
}

@media (max-width: 600px) {
  .feature-card-wrapper {
    flex: 1 1 100%;
    max-width: none;
  }

  .feature-card-container {
    gap: 12px;
  }
}
</style>

